<template>
	<div class="app-card-row">
		<slot />
	</div>
</template>

<style lang="scss">
.app-card-row {
	display: flex;
	flex-direction: row;
	gap: 25px;

	@media screen and (max-width: 1000px) {
		flex-direction: column;
	}
}
</style>
